/* "Your Style, Your Story" strip — sections/your-style.liquid.
   A dependency-free stand-in for the Swiper slider it replaces, with the same behaviour:
   loop, 300ms slides, prev/next arrows, swipe and mouse-drag (Swiper's short/long swipe
   rules), 2.3 per view left-aligned, centred 4 per view from 767px (widths in the CSS).
   The track moves with a transform; once a move lands the slides' flex `order` rotates so
   the active one sits mid-row with slides either side (nothing moves in the DOM). */
(function () {
  'use strict';

  var SPEED = 300; // Swiper `speed`
  var EASE = 'transform ' + SPEED + 'ms ease';
  var centred = window.matchMedia('(min-width: 767px)'); // Swiper breakpoint: centeredSlides
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.__ys) return;
    root.__ys = true;
    var viewport = root.querySelector('.ys__viewport');
    var track = root.querySelector('[data-ys-track]');
    if (!track) return;
    var items = [].slice.call(track.querySelectorAll('[data-ys-slide]'));
    if (items.length < 2) return;

    // Up to 5 slides show at once on desktop (one moving in): a short set is repeated so the
    // loop never runs out. Copies are out of the tab order and the accessibility tree — but not
    // `inert`, which made them untouchable: a swipe starting on one did nothing.
    var originals = items.slice();
    while (items.length < 7) {
      originals.forEach(function (slide) {
        var copy = slide.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('a, button, [tabindex]').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        copy.removeAttribute('data-shopify-editor-block');
        track.appendChild(copy);
        items.push(copy);
      });
    }

    var n = items.length;
    var mid = Math.floor(n / 2);
    var start = 0; // which item sits at visual position 0
    var active = 0; // the active item once a move has landed
    var x = 0;
    var landing = 0;
    var drag = null;
    var dragged = false;

    function gap() {
      return parseFloat(getComputedStyle(track).columnGap) || 0;
    }
    function step() {
      return items[0].getBoundingClientRect().width + gap();
    }
    // Where the track sits with item position `pos` active (left edge, or centred)
    function offsetFor(pos) {
      var off = -pos * step();
      if (centred.matches) off += (track.clientWidth - items[0].getBoundingClientRect().width) / 2;
      return off;
    }
    function move(px, animate) {
      x = px;
      track.style.transition = animate && !reduceMotion.matches ? EASE : 'none';
      track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
    }
    function arrange(first) {
      start = ((first % n) + n) % n;
      items.forEach(function (el, i) {
        el.style.order = (i - start + n) % n;
      });
    }
    // Item i active in the middle of the row, `extra` px from its resting place
    function centre(i, extra) {
      active = i;
      arrange(i - mid);
      move(offsetFor(mid) + (extra || 0), false);
    }
    // The visual position the track is at (fractional)
    function position() {
      return (offsetFor(0) - x) / step();
    }
    function land() {
      landing = 0;
      var at = Math.round(position());
      centre((((start + at) % n) + n) % n);
    }
    function slideTo(pos) {
      move(offsetFor(Math.max(0, Math.min(n - 1, pos))), true);
      clearTimeout(landing);
      landing = setTimeout(land, SPEED + 30);
    }
    // A new move while one is under way carries on from where the track is
    function catchTrack() {
      if (!landing) return;
      clearTimeout(landing);
      landing = 0;
      var t = getComputedStyle(track).transform;
      if (t && t !== 'none' && window.DOMMatrixReadOnly) x = new DOMMatrixReadOnly(t).m41;
      var at = Math.round(position());
      var extra = x - offsetFor(at);
      centre((((start + at) % n) + n) % n, extra);
    }

    // Arrows
    var prev = root.querySelector('[data-ys-prev]');
    var next = root.querySelector('[data-ys-next]');
    if (prev) prev.addEventListener('click', function () {
      catchTrack();
      slideTo(Math.round(position()) - 1);
    });
    if (next) next.addEventListener('click', function () {
      catchTrack();
      slideTo(Math.round(position()) + 1);
    });

    // Swipe / mouse drag. Swiper's rules: under 300ms a swipe moves one slide its way; a longer
    // drag lands on whichever slide it has moved at least half-way onto. Listened for on the
    // viewport, not the moving track, so a press in a gap or on a copy still counts.
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (!track.contains(e.target)) return; // the arrows
      // a second finger is a pinch (the page zooms): finish on the nearest slide instead
      if (drag) {
        if (e.pointerId !== drag.id) {
          drag = null;
          track.classList.remove('is-dragging');
          settle();
        }
        return;
      }
      catchTrack();
      dragged = false;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, base: x, axis: '', t0: e.timeStamp };
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      // a mouse let go outside (no pointerup here): don't drag the strip on hover
      if (e.pointerType === 'mouse' && !(e.buttons & 1)) return release(e);
      var dx = e.clientX - drag.x0;
      var dy = e.clientY - drag.y0;
      if (!drag.axis) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return; // Swiper `threshold`
        drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (drag.axis === 'y') {
          drag = null; // the page scrolls
          return settle();
        }
        dragged = true;
        track.classList.add('is-dragging');
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      move(drag.base + dx, false);
      // However far the drag goes, keep slides queued on both sides (as Swiper's loop does):
      // past a slide from the middle, rotate the row under the pointer and carry on
      var p = position();
      if (Math.abs(p - mid) >= 1) {
        var at = Math.round(p);
        var before = x;
        centre((((start + at) % n) + n) % n, x - offsetFor(at));
        drag.base += x - before;
      }
    });
    function release(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      track.classList.remove('is-dragging');
      if (d.axis !== 'x') return settle();
      var p = position();
      var stop = Math.floor(p);
      var ratio = p - stop;
      var forward = x < d.base; // dragged left: towards the next slide
      var target;
      if (e.type === 'pointercancel') target = Math.round(p);
      else if (e.timeStamp - d.t0 < 300) target = forward ? stop + 1 : stop;
      else target = ratio >= 0.5 ? stop + 1 : stop;
      slideTo(target);
    }
    viewport.addEventListener('pointerup', release);
    viewport.addEventListener('pointercancel', release);
    // Once a drag is sideways, cancel the touch's own scrolling, as Swiper does: otherwise
    // Chrome takes the swipe for a fling and spends the next tap stopping it (no click)
    viewport.addEventListener('touchmove', function (e) {
      if (drag && drag.axis === 'x' && e.cancelable) e.preventDefault();
    }, { passive: false });
    // a tap or page scroll that caught the track mid-move: finish on the nearest slide
    function settle() {
      var p = position();
      if (Math.abs(p - Math.round(p)) > 0.002) slideTo(Math.round(p));
    }
    // a drag isn't a click on the image link
    track.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true);

    // Tabbing to a link that is off to the side brings its slide into view
    track.addEventListener('focusin', function (e) {
      var slide = e.target.closest('[data-ys-slide]');
      if (!slide) return;
      var r = slide.getBoundingClientRect();
      var v = viewport.getBoundingClientRect();
      if (r.left >= v.left && r.right <= v.right) return;
      catchTrack();
      clearTimeout(landing);
      landing = 0;
      centre(items.indexOf(slide));
    });

    // Re-place on resize (slide widths change) and when crossing the 767px breakpoint
    var lastWidth = 0;
    function reset() {
      var w = track.clientWidth;
      if (w === lastWidth) return;
      lastWidth = w;
      clearTimeout(landing);
      landing = 0;
      centre(active);
    }
    reset();
    window.addEventListener('resize', reset);
    if (centred.addEventListener) centred.addEventListener('change', function () {
      lastWidth = 0;
      reset();
    });
  }

  document.querySelectorAll('[data-ys]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-ys]'));
  });
})();
